import Splide from '@splidejs/splide';

export const initProsSlider = () => {
  const slider = new Splide('[data-pro-custom-installer-pros-slider]', {
    type: 'fade',
    easing: 'cubic-bezier(0,0,.54,.98)',
    speed: 600,
    rewind: true,
    arrows: true,
    pagination: false,
  }).mount();

  const scrollDirection = {
    left: 'LEFT',
    right: 'RIGHT',
  };

  slider.on('move', (newIndex, currentIndex) => {
    const direction = getSliderScrollDirection(
      newIndex,
      currentIndex,
      slider.length - 1
    );
    const currentSlide = slider.Components.Elements.slides[currentIndex];
    const newSlide = slider.Components.Elements.slides[newIndex];
    const currentInterviewTile = currentSlide.querySelector(
      '[data-pro-custom-installer-pros-interview]'
    );
    const newInterviewTile = newSlide.querySelector(
      '[data-pro-custom-installer-pros-interview]'
    );

    if (currentInterviewTile && currentInterviewTile.classList) {
      currentInterviewTile.classList.remove(
        'pro-custom-installer-pros__interview--prev',
        'pro-custom-installer-pros__interview--next'
      );
    }

    if (newInterviewTile && newInterviewTile.classList) {
      newInterviewTile.classList.remove(
        'pro-custom-installer-pros__interview--prev',
        'pro-custom-installer-pros__interview--next'
      );
    }

    if (currentInterviewTile && currentInterviewTile.classList) {
      if (direction === scrollDirection.right) {
        currentInterviewTile.classList.add(
          'pro-custom-installer-pros__interview--next'
        );
      } else {
        currentInterviewTile.classList.add(
          'pro-custom-installer-pros__interview--prev'
        );
      }
    }
  });

  function getSliderScrollDirection(newIndex, currentIndex, maxIndex) {
    let direction = '';
    const isShiftFromLastToFirst = currentIndex === maxIndex && newIndex === 0;
    const isShiftFromFirstToLast = newIndex === maxIndex && currentIndex === 0;

    if (isShiftFromLastToFirst) {
      direction = scrollDirection.right;
    } else if (isShiftFromFirstToLast) {
      direction = scrollDirection.left;
    } else if (newIndex > currentIndex) {
      direction = scrollDirection.right;
    } else {
      direction = scrollDirection.left;
    }

    return direction;
  }
};
